import SearchProvider from '../data/schema/SearchProvider';

export default function isSubstrateSearchProvider(
    searchProvider: SearchProvider | null | undefined
): boolean {
    return (
        searchProvider === SearchProvider.Substrate ||
        searchProvider === SearchProvider.SubstrateV2 ||
        searchProvider === SearchProvider.SubstrateV3
    );
}
